<template>

  <footer class="bulk-issue-action-footer">

    <div class="bulk-issue-action-footer__summary">
       <strong class="bulk-issue-action-footer__title">{{ summary.title }}</strong
      > <span class="bulk-issue-action-footer__amount">{{ summary.amount }}</span
      > <span
        v-if="summary.blockedHint"
        class="bulk-issue-action-footer__hint"
        >{{ summary.blockedHint }}</span
      >
    </div>

    <div class="bulk-issue-action-footer__actions">
       <b-button
        variant="secondary"
        @click="$emit('cancel')"
        >{{ cancelLabel }}</b-button
      > <b-button
        v-if="showPrimary"
        variant="primary"
        :disabled="primaryDisabled"
        @click="$emit('confirm')"
        >{{ primaryLabel }}</b-button
      >
    </div>

  </footer>

</template>

<script>
  export default {
    name: 'BulkIssueActionFooter',
    props: {
      summary: {
        type: Object,
        default: () => ({
          title: '',
          amount: '',
          blockedHint: '',
        }),
      },
      cancelLabel: {
        type: String,
        default: 'Hủy',
      },
      primaryLabel: {
        type: String,
        default: '',
      },
      primaryDisabled: {
        type: Boolean,
        default: false,
      },
      showPrimary: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>

<style scoped>
  .bulk-issue-action-footer {
    position: sticky;
    bottom: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.9rem 1rem;
    margin-top: auto;
    border-top: 1px solid #e1e7ef;
    background: rgba(255, 255, 255, 0.97);
  }

  .bulk-issue-action-footer__summary {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.18rem;
  }

  .bulk-issue-action-footer__title {
    color: #1f2a3d;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .bulk-issue-action-footer__amount {
    color: #445166;
    font-size: 0.84rem;
    font-weight: 600;
  }

  .bulk-issue-action-footer__hint {
    color: #8a94a5;
    font-size: 0.78rem;
    line-height: 1.35;
  }

  .bulk-issue-action-footer__actions {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    flex-shrink: 0;
  }

  @media (max-width: 767.98px) {
    .bulk-issue-action-footer {
      flex-direction: column;
      align-items: stretch;
    }

    .bulk-issue-action-footer__actions {
      width: 100%;
      justify-content: stretch;
      flex-direction: column;
    }
  }
</style>

